import Modal from '@/components/ui/modals';
import { useTranslations } from 'next-intl';
import { Button } from '@/components/ui/buttons';
import { Spinner } from '@/components/ui/forms';
import ProductCard from '../product-card';
import { Form, Formik } from 'formik';
import Input from '@/components/ui/inputFormik';
import { rateProductValidation } from '@/utils/validation/user';

const initialValues = {
  message: '',
};

function RateModal({ product, isOpen, onClose, isLoading, onRate }) {
  const t = useTranslations();

  const handleSubmit = async (values, { setSubmitting }) => {
    await onRate(values?.message || '');
    setSubmitting(false);
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={t('user.rate_product_key')}
      maxWidth='max-w-lg'
    >
      <div className='px-4 py-8'>
        <div className='my-4'>
          <ProductCard product={product} />
        </div>
        <div>
          <Formik
            initialValues={initialValues}
            validationSchema={rateProductValidation(t)}
            onSubmit={handleSubmit}
          >
            {({ isSubmitting }) => (
              <Form method='POST'>
                <div>
                  <Input
                    name='message'
                    rows={5}
                    as='textarea'
                    placeholder={t('user.rate_product_key')}
                  />
                </div>
                <div className='mt-6 flex justify-center gap-4'>
                  <Button
                    type='submit'
                    className='w-48'
                    disabled={isLoading || isSubmitting}
                  >
                    {t('user.rate_product_key')}
                    {(isLoading || isSubmitting) && <Spinner />}
                  </Button>
                  <Button
                    type='button'
                    onClick={onClose}
                    className='text-primary! border-border border-2 bg-transparent px-18'
                  >
                    {t('common.cancel_key')}
                  </Button>
                </div>
              </Form>
            )}
          </Formik>
        </div>
      </div>
    </Modal>
  );
}

export default RateModal;
